export default {
  getUrlQuery(url = null) {
    url = url || decodeURIComponent(location.search) // 获取url中"?"符后的字串(包括问号)
    let query = {}
    if (url.indexOf("?") != -1) {
      // const str = url.substr(1)
      // const pairs = str.split("&")
      let str = url.split("?")
      str = str.pop()
      const pairs = str.split("&")
      for (let i = 0; i < pairs.length; i++) {
        const pair = pairs[i].split("=")
        query[pair[0]] = pair[1]
      }
    }
    return query // 返回对象
  }
}
